// Package 4, part M (owner, 7. 10. 2026; "Rebrand: AFTER DAY"): the game's name and home. "Last Day" stays as the event
// in the world of the game (the day everyone who took MEND turned); internal ids (`@lastday/shared`, keys) stay as they are.

export const BRAND = {
  /** The name as the logo and titles write it. */
  name: 'AFTER DAY',
  /** In a sentence ("Join … in After Day"). */
  title: 'After Day',
  /** The new home (part M: DNS, Caddy and TLS by the owner). */
  domain: 'playafterday.com',
  url: 'https://playafterday.com',
} as const;
